import { render, staticRenderFns } from "./paymentCheck.vue?vue&type=template&id=08d72e6b&scoped=true&"
import script from "./paymentCheck.vue?vue&type=script&lang=js&"
export * from "./paymentCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d72e6b",
  null
  
)

export default component.exports